import * as Sentry from '@sentry/react';
import { createBrowserHistory } from '@tanstack/react-router';

interface DrawerNavigationGuard {
    requestCloseAll: () => boolean;
    shouldBlockUnload: () => boolean;
}

export const navigationHistory = createBrowserHistory();
let drawers: DrawerNavigationGuard | undefined;

const unregister = navigationHistory.block({
    blockerFn: ({ currentLocation, nextLocation }) => {
        const urlChanged =
            currentLocation.pathname !== nextLocation.pathname ||
            currentLocation.search !== nextLocation.search ||
            currentLocation.hash !== nextLocation.hash;
        try {
            return urlChanged && !!drawers && !drawers.requestCloseAll();
        } catch (error) {
            Sentry.captureException(error);
            return true;
        }
    },
    enableBeforeUnload: () => drawers?.shouldBlockUnload() ?? false,
});

export const registerDrawerNavigationGuard = (guard: DrawerNavigationGuard) => {
    drawers = guard;
    return () => {
        if (drawers === guard) {
            drawers = undefined;
        }
    };
};

if (import.meta.hot) {
    import.meta.hot.dispose(() => {
        unregister();
        navigationHistory.destroy();
    });
}
